export const sections = [
  {
    title: "Business Details",
    questions: [
      { id: 'businessName', label: 'Business name', type: 'text', required: true },
      { id: 'businessEmail', label: 'Business email', type: 'text', required: true },
      { id: 'tagline', label: 'Tagline or slogan', type: 'text' },
      { id: 'industry', label: 'Industry / sector', type: 'text', required: true },
      { id: 'description', label: 'Business description (1–3 sentences)', type: 'textarea', required: true },
      { id: 'problemSolved', label: 'What specific problem do you solve?', type: 'textarea', required: true },
      { id: 'differentiation', label: 'Unique Selling Proposition (USP)', type: 'textarea', required: true },
      { id: 'geographicFocus', label: 'Geographic focus', type: 'select', options: ['Local', 'National', 'International', 'Specific regions', 'Other'], required: true }
    ]
  },
  {
    title: "Market & Competition",
    questions: [
      { id: 'competitors', label: 'Direct Competitors (URLs or Names)', type: 'textarea' },
      { id: 'marketPosition', label: 'Desired Market Position', type: 'select', options: ['Budget-friendly', 'Mid-market', 'Premium/Luxury', 'Disruptor', 'Other'], required: true },
      { id: 'inspirationSites', label: 'Websites you admire (and why)', type: 'textarea' }
    ]
  },
  {
    title: "Target Audience",
    questions: [
      { id: 'primaryAudience', label: 'Primary audience profile', type: 'textarea', required: true },
      { id: 'painPoints', label: 'What keeps them up at night?', type: 'textarea', required: true },
      { id: 'objections', label: 'Common objections they have', type: 'textarea', required: true },
      { id: 'audienceGoals', label: 'What is their "Dream Outcome"?', type: 'textarea', required: true },
      { id: 'sophisticationLevel', label: 'Audience sophistication', type: 'select', options: ['Beginner', 'Mixed', 'Expert', 'Other'], required: true },
      { id: 'emotionalState', label: 'Tone when arriving on site', type: 'textarea', required: true }
    ]
  },
  {
    title: "Website Objectives",
    questions: [
      { id: 'primaryGoal', label: 'Primary Conversion Goal', type: 'select', options: ['Lead generation', 'E-commerce Sales', 'Booking/Appointment', 'Education', 'Portfolio', 'Other'], required: true },
      { id: 'desiredAction', label: 'The "Big Button" Action (CTA)', type: 'text', required: true },
      { id: 'successMetric', label: 'What does success look like in 6 months?', type: 'text', required: true }
    ]
  },
  {
    title: "Brand & Visual Direction",
    questions: [
      { id: 'brandPersonality', label: 'Brand personality (3-6 adjectives)', type: 'textarea', required: true },
      { id: 'toneOfVoice', label: 'Tone of voice', type: 'select', options: ['Formal', 'Casual', 'Professional', 'Playful', 'Luxury', 'Authoritative', 'Other'], required: true },
      { id: 'visualStyle', label: 'Visual style', type: 'select', options: ['Minimalist', 'Bold', 'Corporate', 'Creative', 'Luxury', 'Technical', 'Other'], required: true },
      { id: 'brandColors', label: 'Existing colors/palette', type: 'color-palette' },
      { id: 'imageStyle', label: 'Preferred imagery', type: 'select', options: ['Photography', 'Illustration', 'Icons', 'Video', 'Mixed', 'Other'], required: true }
    ]
  },
  {
    title: "Structure & Content",
    questions: [
      { id: 'requiredPages', label: 'Required standard pages', type: 'checkbox', options: ['Home', 'About', 'Services', 'Products', 'Case Studies', 'Blog', 'Contact', 'FAQ', 'Legal'], required: true },
      { id: 'customPages', label: 'Additional custom pages', type: 'textarea', placeholder: 'List any other pages you need (e.g., Portfolio, Team, Careers, Booking...)' },
      { id: 'priorityPages', label: 'Which page is the absolute priority?', type: 'text', required: true },
      { id: 'seoKeywords', label: 'Target SEO keywords', type: 'textarea' }
    ]
  }
];